import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';

// Hàm giải mã token (Copy từ các file khác hoặc tách ra file utils riêng dùng chung)
const parseJwt = (token) => {
    try {
        if (!token) return null;
        const base64Url = token.split('.')[1];
        const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
        const jsonPayload = decodeURIComponent(window.atob(base64).split('').map(function (c) {
            return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
        }).join(''));
        return JSON.parse(jsonPayload);
    } catch (e) {
        return null;
    }
};

const ProtectedRoute = ({ allowedRoles }) => {
    const token = localStorage.getItem('skillmatch_token');
    
    // 1. Kiểm tra đăng nhập
    if (!token) {
        return <Navigate to="/login" replace />;
    }

    const decoded = parseJwt(token);
    const user = decoded?.user;

    // 2. Kiểm tra Role
    // Nếu role của user KHÔNG nằm trong danh sách cho phép (allowedRoles)
    if (allowedRoles && !allowedRoles.includes(user.role)) {
        // Điều hướng về trang phù hợp với role của họ
        if (user.role === 'business') {
            return <Navigate to="/business/dashboard" replace />;
        } else if (user.role === 'candidate') {
            return <Navigate to="/" replace />; // Hoặc /candidate/profile
        } else if (user.role === 'admin') {
            return <Navigate to="/admin/dashboard" replace />;
        } else {
            return <Navigate to="/login" replace />;
        }
    }

    // 3. Nếu hợp lệ -> Cho phép truy cập (Render trang con)
    return <Outlet />;
};

export default ProtectedRoute;